import styled from 'styled-components';

import { Box } from 'components/Box';
import { cssBreakpoints } from 'theme';

export const PageHeaderContainer = styled(Box)<{ $fullSize?: boolean }>`
  ${({ $fullSize }) => `
    font-size: 20px;
    line-height: 2.5;
    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      font-size: ${CURRENT_LOCALE === 'en' || !$fullSize ? 13 : 12}px;
      line-height: normal;
    }
    ${
      CURRENT_LOCALE !== 'en' && $fullSize
        ? `
      @media all and (min-width: 1350px) {
        font-size: 13px;
      }
    `
        : ''
    }
    @media all and (min-width: ${
      CURRENT_LOCALE === 'en' || !$fullSize ? 1400 : 1475
    }px) {
      font-size: 14px;
    }
    ${
      $fullSize
        ? `
      @media all and (min-width: ${CURRENT_LOCALE === 'en' ? 1450 : 1600}px) {
        font-size: 15px;
      }
    `
        : ''
    }
  `}
  pointer-events: none;
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    pointer-events: auto;
  }
`;
